import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthUseCase } from "@gui/contexts/useCases/UseCasesContext";

/**
 * Logs the user out and redirects to /login. Single-shot effect on mount —
 * the view is presentational ("Please wait...") while this runs.
 */
export function useLogoutViewModel(): void {
	const navigate = useNavigate();
	const auth = useAuthUseCase();

	useEffect(() => {
		auth.logout();
		navigate("/login", { replace: true });
	}, []);
}
